import { FileStorePagination } from "#/api/fileStore.type";
import { MediaSearchParams } from "#/lib/mediaApi";

export const qk = {
  fileStoreList: (params?: FileStorePagination) =>
    ["file-store", "list", params ?? {}] as const,
  fileStore: (id: string) => ["file-store", id] as const,
  notificationPreferences: () => ["notificationPreferences"] as const,
  adminNotifications: () => ["adminNotifications"] as const,
  groupChat: (id: string) => ["groupChat", id] as const,
  adminUsersWithMessages: () => ["admin", "users-with-messages"] as const,
  calls: (params?: { limit?: number; offset?: number }) =>
    ["calls", params ?? {}] as const,
  callMessages: (
    callId: string,
    params?: { limit?: number; offset?: number }
  ) => ["calls", callId, "messages", params ?? {}] as const,
  voiceAgents: () => ["voice", "agents"] as const,
  messageTemplates: (params?: {
    limit?: number;
    offset?: number;
    q?: string;
  }) => ["message-templates", "list", params ?? {}] as const,
  messageTemplateDetail: (id: string) =>
    ["message-templates", "detail", { id }] as const,
  messageTemplateSnippet: (params: { id: string; contextKey: string }) =>
    ["message-templates", "snippet", params] as const,
  outreachSettingsList: () => ["outreach-settings", "list"] as const,
  outreachSettingsDetail: (id: string) =>
    ["outreach-settings", "detail", { id }] as const,
  articleOutlines: () => ["article-outlines", "list"] as const,
  articleOutlineDetail: (id: string) =>
    ["article-outlines", "detail", { id }] as const,
  articles: () => ["articles", "list"] as const,
  articleDetail: (slug: string) => ["articles", "detail", { slug }] as const,
  articleRevisions: (articleId: string) =>
    ["articles", "revisions", { articleId }] as const,
  articleReviews: (params?: { articleId?: string; revisionId?: string }) =>
    ["article-reviews", "list", params ?? {}] as const,
  articleReviewDetail: (id: string) =>
    ["article-reviews", "detail", { id }] as const,
  articleReviewsArticles: () => ["article-reviews", "articles"] as const,
  medicalConceptsList: (params?: { query?: string; limit?: number }) =>
    ["medical-concepts", "list", params ?? {}] as const,
  medicalConceptDetail: (id: string) =>
    ["medical-concepts", "detail", { id }] as const,
  medicalConceptRelated: (id: string) =>
    ["medical-concepts", "related", { id }] as const,
  medicalConceptOutlines: (id: string) =>
    ["medical-concepts", "outlines", { id }] as const,
  medicalConceptArticles: (id: string) =>
    ["medical-concepts", "articles", { id }] as const,
  mediaSearch: (params?: MediaSearchParams) =>
    ["media", "search", params ?? {}] as const,
  mediaDetail: (idOrSlug: string) => ["media", "detail", { idOrSlug }] as const,
};
